import type { MessagingCreateChatRoom201BasicInfoAllOfTwoType } from './messagingCreateChatRoom201BasicInfoAllOfTwoType';

/**
 * 채팅방 기본 정보
 */
export type MessagingCreateChatRoom201BasicInfoAllOfTwo = {
  name?: string;
  type?: MessagingCreateChatRoom201BasicInfoAllOfTwoType;
};
